export const notifyMixin = {
  mounted() {
    // notify redirect messages
    $(function() {
      if (localStorage.getItem('notify-message')) {
        Lagina.notify(localStorage.getItem('notify-type'), localStorage.getItem('notify-message'));
        localStorage.removeItem('notify-message');
        localStorage.removeItem('notify-type');
      }
    });
  },
  methods: {
    notify(type, message) {
      new Noty({
        text: message,
        type: type,
      }).show();
    },

    notifyError(message) {
      this.notify('error', message);
    },

    notifySuccess(message) {
      this.notify('success', message);
    },

    notifyOnRedirect(message, type = 'success') {
      localStorage.setItem('notify-message', message);
      localStorage.setItem('notify-type', type);
    },
  }
};
